import { createTheme } from '@mui/material/styles';

/**
 * Builds an enterprise theme with clean surfaces, crisp borders, and a calm accent.
 * Accent choice: Deep Navy (trust/finance friendly).
 *
 * @param {'light'|'dark'} mode
 */
export function buildTheme(mode = 'light') {
  const isDark = mode === 'dark';

  // Professional accent: Deep Navy Blue (calm, high-trust)
  // Alternatives (also professional):
  // - Indigo:   #3F51B5
  // - Teal:     #0F766E
  // - Charcoal: #334155 (subtle)
  const primaryMain = '#1E3A8A';

  const bgDefault = isDark ? '#0f1115' : '#f4f5f7';
  const bgPaper = isDark ? '#151922' : '#ffffff';
  const divider = isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.10)';

  return createTheme({
    palette: {
      mode,
      primary: { main: primaryMain },
      background: { default: bgDefault, paper: bgPaper },
      divider,
    },
    shape: { borderRadius: 12 },
    typography: {
      fontFamily: [
        'Inter',
        'system-ui',
        '-apple-system',
        'Segoe UI',
        'Roboto',
        'Arial',
        'sans-serif',
      ].join(','),
      h4: { fontWeight: 800 },
      h6: { fontWeight: 800 },
      button: { textTransform: 'none', fontWeight: 700 },
    },
    components: {
      MuiAppBar: { styleOverrides: { root: { backgroundImage: 'none' } } },
      MuiCard: {
        styleOverrides: {
          root: {
            border: `1px solid ${divider}`, // better definition than only shadow
            boxShadow: isDark
              ? '0 10px 28px rgba(0,0,0,0.46)'
              : '0 10px 26px rgba(0,0,0,0.10)',
          },
        },
      },
      MuiButton: { styleOverrides: { root: { borderRadius: 10 } } },
    },
  });
}
